import { POINTS_TYPES } from "../types/pointsTypes";

export const getUpdatedPoints = (uuid) => ({
    type: POINTS_TYPES.GET_POINTS,
    payload: {uuid},
})
